export class PlateScanDTO{
    machine!: string;
    source!: string;
    lysis!: string;
    aliquot!: string;
    dna!: string;
    pgx!: string;
    wga!: string;
    magmix!: string;
    merge!: string;
    array!: string;
    batchID:string;
}
